import { musicsConstants } from "./constants/musicsConstant";

const musicsSave = (id:any, musicsInput: any) => {
	return {
		type: musicsConstants.MusicsSaveRequest,
		input: {musicsInput: musicsInput, id: id}
	};
};

const musicsGetByfilter = (musicsInput: any) => {
	return {
		type: musicsConstants.MusicsGetByfilterRequest,
		input: musicsInput
	};
};

const musicsGetDetail = (id: any) => {
	return {
		type: musicsConstants.MusicsDetailRequest,
		input: { id: id }
	};
};

const musicsDelete = (id: any) => {
	return {
		type: musicsConstants.MusicsDeleteRequest,
		input: id
	};
};

const updateMusicVideoStatus = (data: any) => {
	return {
		type: musicsConstants.MusicsVideoStatusUpdateRequest,
		input: data
	};
};

export const musicsAction = {
	musicsSave,
	musicsGetByfilter,
	musicsGetDetail,
	musicsDelete,
	updateMusicVideoStatus
}